<app-register [promotionData]="promo"></app-register>
